export default "__VITE_ASSET__CJIH7w5n__"